import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  imageContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    padding: "1rem",
    position: "relative",
    backgroundColor: theme.palette.purple,
  },
  extraMargin: {
    [theme.breakpoints.up('md')]: {
      marginBottom: "1rem"
    },
  },
  image: {
    width: "100%"
  },
  captionContainer: {
    backgroundColor: theme.palette.purple,
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.up('md')]: {
      position: "absolute",
      right: "0",
      bottom: "-1.4rem",
      padding: "0.5rem 1rem",
    },
  },
  caption: {
    color: theme.palette.white,
    fontSize: "1.5rem"
  }
}));
